<template>
  <!--隐藏的分享-->
<!--  <div class="shadow_nr" v-show="shareBox" v-on:click="cancelshareBox(false)" style="z-index: 999;">-->
<!--    <transition name="pull-up">-->
<!--      <div class="shadow-cont" v-on:click="clickTest" v-show="shareShow">-->
<!--        <div class="share-list fx-bjf8">-->
<!--          <ul class="clear">-->
<!--            <li @click="shareWxFriends">-->
<!--              <p class="item-con i1"></p>-->
<!--              <p class="item-text">微信好友</p>-->
<!--            </li>-->
<!--            <li @click="shareWxCircle">-->
<!--              <p class="item-con i2"></p>-->
<!--              <p class="item-text">朋友圈</p>-->
<!--            </li>-->
<!--            <li @click="shareQQ">-->
<!--              <p class="item-con i3"></p>-->
<!--              <p class="item-text">QQ</p>-->
<!--            </li>-->
<!--            <li @click="shareQzone">-->
<!--              <p class="item-con i4"></p>-->
<!--              <p class="item-text">QQ空间</p>-->
<!--            </li>-->
<!--&lt;!&ndash;            <li @click="shareSina">&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="item-con i10"></p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="item-text">新浪微博</p>&ndash;&gt;-->
<!--&lt;!&ndash;            </li>&ndash;&gt;-->
<!--          </ul>-->
<!--        </div>-->
<!--        <div class="share-list fx-bjf8">-->
<!--          <ul class="clear">-->
<!--            <li v-if="removeIcon" @click="deleteItem">-->
<!--              <p class="item-con i9"></p>-->
<!--              <p class="item-text red">删除</p>-->
<!--            </li>-->
<!--            <li v-if="!favorateIcon&&favorateShow" @click="favorateItem">-->
<!--              <p class="item-con i5"></p>-->
<!--              <p class="item-text">收藏</p>-->
<!--            </li>-->
<!--            <li v-if="favorateIcon&&favorateShow" @click="favorateCancel">-->
<!--              <p class="item-con i5"></p>-->
<!--              <p class="item-text">取消收藏</p>-->
<!--            </li>-->
<!--            &lt;!&ndash;<li>&ndash;&gt;-->
<!--            &lt;!&ndash;<p class="item-con i6"></p>&ndash;&gt;-->
<!--            &lt;!&ndash;<p class="item-text">只看楼主</p>&ndash;&gt;-->
<!--            &lt;!&ndash;</li>&ndash;&gt;-->
<!--            <li v-if="reportIcon" @click="reportItem">-->
<!--              <p class="item-con i7"></p>-->
<!--              <p class="item-text">举报</p>-->
<!--            </li>-->
<!--            <li v-if="reverseIcon" @click="reverseComment">-->
<!--              <p class="item-con i8"></p>-->
<!--              <p class="item-text">倒序排列</p>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->
<!--        <div class="cancel" @click="cancelshareBox(false)">取消</div>-->
<!--      </div>-->
<!--    </transition>-->
<!--  </div>-->

</template>


<script>
import {post} from '@/assets/js/json'
import router from '@/router'
import deepCopy from 'json-deep-copy'
import {closeLoading, getShareService, showLoading} from '@/assets/js/native'

export default {
  data () {
    return {
      shareBox: false,
      favorateIcon: '',
      favorateShow: '',
      removeIcon: false,
      reverseIcon: false,
      reportIcon: false,
      comment: [],
      item: {},
      type: 'article',
      shareMessage: {},
      shareShow: false
    }
  },
  methods: {
    cancelshareBox (val) {
      if (!val) {
        this.shareShow = val
        setTimeout(() => {
          this.shareBox = val
        }, 300)
      } else {
        this.shareShow = val
        this.shareBox = val
      }
    },
    clickTest (e) {
      e.stopPropagation()
    },
    reverseComment () {
      if (this.comment && this.comment.length > 0) {
        this.comment.reverse()
      }
      this.shareBox = false
    },
    deleteItem () {
      if (this.item && this.item.id) {
        this.$confirm('确定要删除吗').then(() => {
          if (this.type === 'article') {
            const option = {
              'id': this.item.id
            }
            post('/api/member/article/delete', option).then((res) => {
              if (res.data.success) {
                router.back()
              }
            })
          } else if (this.type === 'post') {
            const option = {
              'postId': this.item.id
            }
            post('/api/member/post/delete', option).then((res) => {
              if (res.data.success) {
                this.$bus.$emit('deleteDynamic', this.item.id)
                router.back()
              }
            })
          }
        })
      }
      this.shareBox = false
    },
    favorateItem () {
      if (this.item && this.item.id) {
        if (this.type === 'article') {
          const option = {
            'articleId': this.item.id
          }
          post('/api/member/article/favorite/add', option).then((res) => {
            if (res.data.success) {
              this.$tips('收藏成功')
              this.favorateIcon = true
              this.$bus.$emit('favorateIconChange', this.favorateIcon)
            }
          })
        } else if (this.type === 'post') {
          const option = {
            'postId': this.item.id
          }
          post('/api/member/post/favorite/add', option).then((res) => {
            if (res.data.success) {
              this.$tips('收藏成功')
              this.favorateIcon = true
              this.$bus.$emit('favorateIconChange', this.favorateIcon)
            }
          })
        }
      }
      this.shareBox = false
    },
    favorateCancel () {
      if (this.item && this.item.id) {
        if (this.type === 'article') {
          const option = {
            'articleId': this.item.id
          }
          post('/api/member/article/favorite/delete', option).then((res) => {
            if (res.data.success) {
              this.$tips('取消收藏成功')
              this.favorateIcon = false
              this.$bus.$emit('favorateIconChange', this.favorateIcon)
            }
          })
        } else if (this.type === 'post') {
          const option = {
            'postId': this.item.id
          }
          post('/api/member/article/favorite/delete', option).then((res) => {
            if (res.data.success) {
              this.$tips('取消收藏成功')
              this.favorateIcon = false
              this.$bus.$emit('favorateIconChange', this.favorateIcon)
            }
          })
        }
      }
      this.shareBox = false
    },
    reportItem () {
      if (this.item && this.item.id) {
        if (this.type === 'article') {
          router.push(`/error?articleId=${this.item.id}`)
        } else if (this.type === 'post') {
          router.push(`/post-report?postId=${this.item.id}`)
        } else {
          router.push(`/user-report?uid=${this.item.id}`)
        }
      }
      this.shareBox = false
    },
    shareWxFriends () {
      const shareMessage = deepCopy(this.shareMessage)
      shareMessage.extra = {
        scene: 'WXSceneSession'
      }
      showLoading()
      getShareService('weixin', shareMessage)
      setTimeout(() => {
        closeLoading()
      }, 1000)
    },
    shareWxCircle () {
      showLoading()
      getShareService('weixin', this.shareMessage)
      setTimeout(() => {
        closeLoading()
      }, 1000)
    },
    shareQQ () {
      showLoading()
      getShareService('qq', this.shareMessage)
      setTimeout(() => {
        closeLoading()
      }, 1000)
    },
    shareQzone () {
      showLoading()
      getShareService('qq', this.shareMessage)
      setTimeout(() => {
        closeLoading()
      }, 1000)
    },
    shareSina () {
      this.shareMessage.content = this.shareMessage.title + this.shareMessage.href
      delete this.shareMessage.href
      getShareService('sinaweibo', this.shareMessage)
    }
  }
}
</script>

<style lang="less" scoped>
  .share-list {
    padding: 10px 0px;
    overflow-x: scroll;
    white-space: nowrap;
    font-size: 0px;
  }

  .share-list:first-child {
    border-bottom: 1px solid #eee;
  }

  .share-list ul {
    overflow-x: scroll;
    white-space: nowrap;
    font-size: 0px;
  }

  .share-list ul li {
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    outline: none;
    width: 22.5%;
  }

  .share-list ul li .item-con {
    margin: 0px auto;
    height: 65px;
    width: 65px;
    background: url(~src/assets/images/share-tb.png) no-repeat;
    background-size: 545px auto;
    display: inline-block;
    vertical-align: middle;
  }

  .share-list ul li .red {
    color: #1c86fb !important;
  }

  .share-list ul li .i1 {
    background-position: -2px 0 !important;
  }

  .share-list ul li .i2 {
    background-position: -81px 0 !important;
  }

  .share-list ul li .i3 {
    background-position: -159px 0 !important;
  }

  .share-list ul li .i4 {
    background-position: -238px 0 !important;
  }

  .share-list ul li .i10 {
    background-position: -317px 0 !important;
  }

  .share-list ul li .i5 {
    background-position: -2px -80px !important;
  }

  .share-list ul li .i6 {
    background-position: -81px -80px !important;
  }

  .share-list ul li .i7 {
    background-position: -159px -80px !important;
  }

  .share-list ul li .i8 {
    background-position: -238px -80px !important;
  }

  .share-list ul li .i9 {
    background-position: -382px -80px !important;
  }

  .share-list ul li .item-text {
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    color: #333;
  }

</style>



// WEBPACK FOOTER //
// src/components/base/share/share.vue